// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Responsive overrides for src/pages/MerchantDetail.jsx.
 * Loaded AFTER index.css (and after the page's own inline \\3c style>) so
 * equal-specificity rules here win by source order.
 *
 * Breakpoints (project standard):
 *   mobile  : <=576px
 *   tablet  : 577–991px
 *   laptop  : 992–1280px
 *   desktop : >=1281px
 *
 * Strategy:
 *   - Tablet (<=991px): header wraps, tabs compact.
 *   - Mobile (<=576px): full single-column layout, tables → card view,
 *     all touch targets >=44px, action buttons full-width.
 *
 * DO NOT EDIT src/index.css. All overrides live here.
 */

/* ===========================================================================
 * TABLET (<=991px): layout adjustments
 * ======================================================================== */
@media (max-width: 991px) {
  /* Allow merchant header card to wrap */
  .merchant-detail-page .merchant-header-card {
    flex-wrap: wrap;
    gap: 1rem;
  }

  /* Overview grid: 1 column on tablet */
  .merchant-detail-page .overview-grid {
    grid-template-columns: 1fr;
  }

  /* Tabs: horizontal scroll without overflow clip */
  .merchant-detail-page .tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }

  .merchant-detail-page .tabs::-webkit-scrollbar {
    display: none;
  }

  /* Pagination: allow wrapping on tablet */
  .merchant-detail-page .pagination-container {
    flex-wrap: wrap;
    gap: 8px;
  }
}

/* ===========================================================================
 * MOBILE (<=576px): full single-column, app-like layout
 * ======================================================================== */
@media (max-width: 576px) {

  /* ---- Page wrapper ---- */
  .merchant-detail-page {
    /* No horizontal overflow */
    overflow-x: hidden;
  }

  /* ---- Back button: larger tap target ---- */
  .merchant-detail-page .back-btn {
    min-height: 44px;
    padding: 0.5rem 0;
  }

  /* ---- Merchant header card: stack vertically ---- */
  .merchant-detail-page .merchant-header-card {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
    padding: 1rem;
  }

  .merchant-detail-page .merchant-header-left {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0.75rem;
  }

  .merchant-detail-page .merchant-header-info h1 {
    font-size: 1.25rem;
  }

  .merchant-detail-page .merchant-meta {
    justify-content: center;
    gap: 0.5rem;
  }

  /* Header right: full-width, stacked */
  .merchant-detail-page .merchant-header-right {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    width: 100%;
  }

  .merchant-detail-page .business-badge {
    justify-content: center;
    width: 100%;
  }

  /* Suspend/Activate button: full-width, min 44px tap target */
  .merchant-detail-page .status-action-btn {
    width: 100%;
    justify-content: center;
    min-height: 44px;
    padding: 0.625rem 1rem;
    font-size: 0.9rem;
  }

  /* ---- Tabs: horizontal scroll, touch-friendly ---- */
  .merchant-detail-page .tabs-container {
    margin-bottom: 1rem;
  }

  .merchant-detail-page .tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    gap: 0;
  }

  .merchant-detail-page .tabs::-webkit-scrollbar {
    display: none;
  }

  .merchant-detail-page .tab {
    flex-shrink: 0;
    padding: 0.75rem 0.875rem;
    min-height: 44px;
    font-size: 0.8rem;
    gap: 0.375rem;
  }

  /* Hide tab labels on very small screens to prevent overflow; icons remain */
  .merchant-detail-page .tab-label-text {
    display: none;
  }

  /* ---- Overview grid: single column ---- */
  .merchant-detail-page .overview-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  /* ---- Detail cards: reduced padding ---- */
  .merchant-detail-page .detail-card {
    padding: 1rem;
    border-radius: 10px;
  }

  /* ---- Info grid: single column ---- */
  .merchant-detail-page .info-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .merchant-detail-page .info-item.full-width {
    grid-column: span 1;
  }

  /* Address display: allow long addresses to wrap */
  .merchant-detail-page .address-display {
    flex-wrap: wrap;
  }

  .merchant-detail-page .address-text {
    min-width: 0;
    flex: 1 1;
  }

  /* Copy button: minimum tap target */
  .merchant-detail-page .copy-btn {
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* ---- Data sections: reduced padding ---- */
  .merchant-detail-page .data-section {
    padding: 1rem;
    border-radius: 10px;
  }

  /* ---- Wallets section: card layout ---- */
  .merchant-detail-page .wallets-section {
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 1rem;
  }

  /* Section header: ensure refresh button is tappable */
  .merchant-detail-page .section-header {
    margin-bottom: 0.75rem;
  }

  .merchant-detail-page .btn-icon {
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* ---- Tables → card view on mobile ---- */

  /* Hide the desktop table */
  .merchant-detail-page .data-table-container {
    overflow: visible;
  }

  .merchant-detail-page .data-table {
    display: none;
  }

  /* Mobile card list: shown via .md-card-list class */
  .merchant-detail-page .md-card-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  /* Each row as a card */
  .merchant-detail-page .md-row-card {
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 12px 14px;
  }

  /* Card header row: primary label + status/badge on right */
  .merchant-detail-page .md-card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
  }

  .merchant-detail-page .md-card-primary {
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--text-primary);
    word-break: break-all;
    min-width: 0;
    flex: 1 1;
  }

  /* Card field rows: label + value pairs */
  .merchant-detail-page .md-card-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 8px;
    padding: 3px 0;
    font-size: 0.8rem;
  }

  .merchant-detail-page .md-card-label {
    color: var(--text-secondary);
    white-space: nowrap;
    flex-shrink: 0;
    font-size: 0.75rem;
  }

  .merchant-detail-page .md-card-value {
    color: var(--text-primary);
    text-align: right;
    word-break: break-word;
    min-width: 0;
  }

  .merchant-detail-page .md-card-value.mono,
  .merchant-detail-page .md-card-primary.mono {
    font-family: 'Monaco', 'Menlo', monospace;
    font-size: 0.75rem;
    word-break: break-all;
  }

  /* Copy button inside table/card */
  .merchant-detail-page .copy-btn-table {
    min-width: 44px;
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.625rem;
  }

  /* ---- Pagination: stack info and controls ---- */
  .merchant-detail-page .pagination-container {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .merchant-detail-page .pagination-info {
    font-size: 0.8rem;
    text-align: center;
  }

  .merchant-detail-page .pagination-controls {
    justify-content: center;
  }

  .merchant-detail-page .pagination-btn {
    min-width: 44px;
    min-height: 44px;
  }

  /* ---- Empty state: reduce padding ---- */
  .merchant-detail-page .empty-state {
    padding: 2rem 1rem;
  }

  /* ---- Stats grid: 2 columns on mobile ---- */
  .merchant-detail-page .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
  }

  /* ---- Error/loading containers ---- */
  .merchant-detail-page .loading-container {
    padding: 2rem 1rem;
  }

  .merchant-detail-page .error-container .btn-primary {
    width: 100%;
    min-height: 44px;
    justify-content: center;
  }
}

/* ===========================================================================
 * Card list hidden on non-mobile (desktop/tablet show the table)
 * ======================================================================== */
.merchant-detail-page .md-card-list {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/MerchantDetail.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;EAiBE;;AAEF;;6EAE6E;AAC7E;EACE,uCAAuC;EACvC;IACE,eAAe;IACf,SAAS;EACX;;EAEA,sCAAsC;EACtC;IACE,0BAA0B;EAC5B;;EAEA,kDAAkD;EAClD;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA,yCAAyC;EACzC;IACE,eAAe;IACf,QAAQ;EACV;AACF;;AAEA;;6EAE6E;AAC7E;;EAEE,2BAA2B;EAC3B;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA,6CAA6C;EAC7C;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,qDAAqD;EACrD;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA,sCAAsC;EACtC;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA,6DAA6D;EAC7D;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA,sDAAsD;EACtD;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,MAAM;EACR;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;EACf;;EAEA,4EAA4E;EAC5E;IACE,aAAa;EACf;;EAEA,2CAA2C;EAC3C;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA,4CAA4C;EAC5C;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,uCAAuC;EACvC;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA,kDAAkD;EAClD;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,SAAW;EACb;;EAEA,oCAAoC;EACpC;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,6CAA6C;EAC7C;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,2CAA2C;EAC3C;IACE,6BAA6B;IAC7B,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;EACf;;EAEA,sDAAsD;EACtD;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,2CAA2C;;EAE3C,2BAA2B;EAC3B;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA,oDAAoD;EACpD;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,uBAAuB;EACvB;IACE,+BAA+B;IAC/B,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,2DAA2D;EAC3D;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;IACrB,YAAY;IACZ,SAAW;EACb;;EAEA,yCAAyC;EACzC;IACE,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,QAAQ;IACR,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,yCAAyC;IACzC,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,kCAAkC;EAClC;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA,kDAAkD;EAClD;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,0CAA0C;EAC1C;IACE,kBAAkB;EACpB;;EAEA,8CAA8C;EAC9C;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA,uCAAuC;EACvC;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;;6EAE6E;AAC7E;EACE,aAAa;AACf","sourcesContent":["/*\n * Responsive overrides for src/pages/MerchantDetail.jsx.\n * Loaded AFTER index.css (and after the page's own inline <style>) so\n * equal-specificity rules here win by source order.\n *\n * Breakpoints (project standard):\n *   mobile  : <=576px\n *   tablet  : 577–991px\n *   laptop  : 992–1280px\n *   desktop : >=1281px\n *\n * Strategy:\n *   - Tablet (<=991px): header wraps, tabs compact.\n *   - Mobile (<=576px): full single-column layout, tables → card view,\n *     all touch targets >=44px, action buttons full-width.\n *\n * DO NOT EDIT src/index.css. All overrides live here.\n */\n\n/* ===========================================================================\n * TABLET (<=991px): layout adjustments\n * ======================================================================== */\n@media (max-width: 991px) {\n  /* Allow merchant header card to wrap */\n  .merchant-detail-page .merchant-header-card {\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n\n  /* Overview grid: 1 column on tablet */\n  .merchant-detail-page .overview-grid {\n    grid-template-columns: 1fr;\n  }\n\n  /* Tabs: horizontal scroll without overflow clip */\n  .merchant-detail-page .tabs {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n\n  .merchant-detail-page .tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Pagination: allow wrapping on tablet */\n  .merchant-detail-page .pagination-container {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n}\n\n/* ===========================================================================\n * MOBILE (<=576px): full single-column, app-like layout\n * ======================================================================== */\n@media (max-width: 576px) {\n\n  /* ---- Page wrapper ---- */\n  .merchant-detail-page {\n    /* No horizontal overflow */\n    overflow-x: hidden;\n  }\n\n  /* ---- Back button: larger tap target ---- */\n  .merchant-detail-page .back-btn {\n    min-height: 44px;\n    padding: 0.5rem 0;\n  }\n\n  /* ---- Merchant header card: stack vertically ---- */\n  .merchant-detail-page .merchant-header-card {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .merchant-detail-page .merchant-header-left {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 0.75rem;\n  }\n\n  .merchant-detail-page .merchant-header-info h1 {\n    font-size: 1.25rem;\n  }\n\n  .merchant-detail-page .merchant-meta {\n    justify-content: center;\n    gap: 0.5rem;\n  }\n\n  /* Header right: full-width, stacked */\n  .merchant-detail-page .merchant-header-right {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n    width: 100%;\n  }\n\n  .merchant-detail-page .business-badge {\n    justify-content: center;\n    width: 100%;\n  }\n\n  /* Suspend/Activate button: full-width, min 44px tap target */\n  .merchant-detail-page .status-action-btn {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n    padding: 0.625rem 1rem;\n    font-size: 0.9rem;\n  }\n\n  /* ---- Tabs: horizontal scroll, touch-friendly ---- */\n  .merchant-detail-page .tabs-container {\n    margin-bottom: 1rem;\n  }\n\n  .merchant-detail-page .tabs {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    gap: 0;\n  }\n\n  .merchant-detail-page .tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .merchant-detail-page .tab {\n    flex-shrink: 0;\n    padding: 0.75rem 0.875rem;\n    min-height: 44px;\n    font-size: 0.8rem;\n    gap: 0.375rem;\n  }\n\n  /* Hide tab labels on very small screens to prevent overflow; icons remain */\n  .merchant-detail-page .tab-label-text {\n    display: none;\n  }\n\n  /* ---- Overview grid: single column ---- */\n  .merchant-detail-page .overview-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  /* ---- Detail cards: reduced padding ---- */\n  .merchant-detail-page .detail-card {\n    padding: 1rem;\n    border-radius: 10px;\n  }\n\n  /* ---- Info grid: single column ---- */\n  .merchant-detail-page .info-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .merchant-detail-page .info-item.full-width {\n    grid-column: span 1;\n  }\n\n  /* Address display: allow long addresses to wrap */\n  .merchant-detail-page .address-display {\n    flex-wrap: wrap;\n  }\n\n  .merchant-detail-page .address-text {\n    min-width: 0;\n    flex: 1 1 0;\n  }\n\n  /* Copy button: minimum tap target */\n  .merchant-detail-page .copy-btn {\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* ---- Data sections: reduced padding ---- */\n  .merchant-detail-page .data-section {\n    padding: 1rem;\n    border-radius: 10px;\n  }\n\n  /* ---- Wallets section: card layout ---- */\n  .merchant-detail-page .wallets-section {\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    padding: 1rem;\n  }\n\n  /* Section header: ensure refresh button is tappable */\n  .merchant-detail-page .section-header {\n    margin-bottom: 0.75rem;\n  }\n\n  .merchant-detail-page .btn-icon {\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* ---- Tables → card view on mobile ---- */\n\n  /* Hide the desktop table */\n  .merchant-detail-page .data-table-container {\n    overflow: visible;\n  }\n\n  .merchant-detail-page .data-table {\n    display: none;\n  }\n\n  /* Mobile card list: shown via .md-card-list class */\n  .merchant-detail-page .md-card-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  /* Each row as a card */\n  .merchant-detail-page .md-row-card {\n    background: var(--bg-secondary);\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    padding: 12px 14px;\n  }\n\n  /* Card header row: primary label + status/badge on right */\n  .merchant-detail-page .md-card-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 8px;\n    margin-bottom: 8px;\n  }\n\n  .merchant-detail-page .md-card-primary {\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: var(--text-primary);\n    word-break: break-all;\n    min-width: 0;\n    flex: 1 1 0;\n  }\n\n  /* Card field rows: label + value pairs */\n  .merchant-detail-page .md-card-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    gap: 8px;\n    padding: 3px 0;\n    font-size: 0.8rem;\n  }\n\n  .merchant-detail-page .md-card-label {\n    color: var(--text-secondary);\n    white-space: nowrap;\n    flex-shrink: 0;\n    font-size: 0.75rem;\n  }\n\n  .merchant-detail-page .md-card-value {\n    color: var(--text-primary);\n    text-align: right;\n    word-break: break-word;\n    min-width: 0;\n  }\n\n  .merchant-detail-page .md-card-value.mono,\n  .merchant-detail-page .md-card-primary.mono {\n    font-family: 'Monaco', 'Menlo', monospace;\n    font-size: 0.75rem;\n    word-break: break-all;\n  }\n\n  /* Copy button inside table/card */\n  .merchant-detail-page .copy-btn-table {\n    min-width: 44px;\n    min-height: 44px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.625rem;\n  }\n\n  /* ---- Pagination: stack info and controls ---- */\n  .merchant-detail-page .pagination-container {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .merchant-detail-page .pagination-info {\n    font-size: 0.8rem;\n    text-align: center;\n  }\n\n  .merchant-detail-page .pagination-controls {\n    justify-content: center;\n  }\n\n  .merchant-detail-page .pagination-btn {\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  /* ---- Empty state: reduce padding ---- */\n  .merchant-detail-page .empty-state {\n    padding: 2rem 1rem;\n  }\n\n  /* ---- Stats grid: 2 columns on mobile ---- */\n  .merchant-detail-page .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n  }\n\n  /* ---- Error/loading containers ---- */\n  .merchant-detail-page .loading-container {\n    padding: 2rem 1rem;\n  }\n\n  .merchant-detail-page .error-container .btn-primary {\n    width: 100%;\n    min-height: 44px;\n    justify-content: center;\n  }\n}\n\n/* ===========================================================================\n * Card list hidden on non-mobile (desktop/tablet show the table)\n * ======================================================================== */\n.merchant-detail-page .md-card-list {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
